import React, { useMemo } from 'react';
import SiteCharts from '../../../components/SiteCharts';
import { saDataRetainabilityCellChartConfig } from '../cellChartConfigs';

interface DataRetainabilitySaCellProps {
  cellName: string;
  onFullscreenToggle: () => void;
  isFullscreen: boolean;
}

const DataRetainabilitySaCell: React.FC<DataRetainabilitySaCellProps> = ({ cellName, onFullscreenToggle, isFullscreen }) => {
  const additionalParams = useMemo(() => ({ cell_name: cellName }), [cellName]);
  return (
    <SiteCharts config={saDataRetainabilityCellChartConfig} onFullscreenToggle={onFullscreenToggle} isFullscreen={isFullscreen} additionalParams={additionalParams} />
  );
};

export default DataRetainabilitySaCell;
